import React, { useState, useEffect, useMemo } from 'react';
import { useSelector,shallowEqual ,useDispatch}      from 'react-redux';
import { NavLink, useNavigate }          from 'react-router-dom';
import { IMAGES_BASE_PATH } from '../../config/constants';
import Footer from "../Layout/footer";
import Header from "../Layout/header";
import NavBar from "../Layout/navbar";
import Default from "../LandingPage/default";
import About from "../LandingPage/about";
import UserHelper from "../../common/utils/userHelper";
import axios from 'axios';
import { API_GATEWAY_URL } from '../../config/constants';
import { getSocialLinksByEventId } from '../../api/eventApi';


type SectionItem = {
  label: string;
  key: string;
  is_show: boolean;
  sort_order: number | null;
  [key: string]: any;
};
;

type LandingPageData = {
  show_social_header?: boolean;
  is_header_banner_video: boolean;
  header_banner_image: any;
  header_banner_video: any;
  sections: SectionItem[];
};

const ConfirmRegistration: React.FC = () => {
    const eventId                               = UserHelper.getEventId();
    const userId                                = UserHelper.getUserId();
    const [data, setData]                       = useState<LandingPageData>();
    const eventData                             = useSelector((state: any) => state.eventData); 
    const [socialData, setSocialData]           = useState<any>();
  
    //const dispatch = useDispatch();
  
  
    useEffect(() => {
      const fetchData = async () => {
        try {
          const res = await axios.get(`${API_GATEWAY_URL}frontend/api/landing-page/event-id/${eventId}`);
          setData(res.data.data);
        } catch (error) {
          console.error('Error fetching landing page data:', error);
        }
      };
  
      fetchData();
    }, [eventId]);

     useEffect(() => {
        const fetchSocialData = async () => {
          try {
            let resposne = await getSocialLinksByEventId(eventData._id);
            console.log('Gallery page data:', resposne);
            setSocialData(resposne);
          } catch (error) {
            console.error('Error fetching gallery page data:', error);
          }
        };
    
        fetchSocialData();
      }, [eventId]);
    
  
  return (
    <>
   <header>
         {/* <div className="header-bottom" id="sticky-header" style={{ background:eventData.theme_header_color }}> */}
            <div className="header-bottom" id="sticky-header">
          <header className="header-area">
              <div className="container-fluid">
                  {/* <!-- Nav --> */}
                  <nav className="navbar navbar-expand-lg">
                      {/* <!-- Logo --> */}
                      <div id="">
                      {eventData?.website_logo?.key && (
                          <NavLink onClick={() => window.location.reload()} to='/' className="">
                              <img
                              src={IMAGES_BASE_PATH + eventData.website_logo.key}
                              alt="logo"
                              />
                          </NavLink>
                      )}
                     
                      </div>
                      {/* <!-- Logo ends! --> */}
                      {/* <!--menu toggler --> */}
                      <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#menu" aria-controls="menu"
                              aria-expanded="false" aria-label="Toggle navigation">
                         <span className="navbar-toggler-icon">
                         <span className="ti-menu"></span>
                         </span>
                      </button>
                      {/* <!--menu toggler ends! --> */}
                      {/* <!--menu --> */}
                      <div className="collapse navbar-collapse" id="menu">
                          <ul id="menu_scroll" className="navbar-nav menu">
                              <li><a href="/" className="scroll active">Home</a></li>
                              <li>
                                <a href="/3D" onClick={()=>{navigate('/3D')}} className="scroll">Login</a>
                                  
                              </li>
              
                            
          
                          </ul>
                      </div>
                      {/* <!--menu ends!--> */}
                     
          
                  </nav>
                
              </div>
          </header>
          
         </div>
       </header>
    <Default/>
    <Footer 
      isSocialFooter={data?.show_social_footer} 
      socialData={socialData} 
      show_partners_footer={data?.show_partners_footer}
      show_newsletter_footer={data?.show_newsletter_footer}
    />
  </>
  );
};
export default ConfirmRegistration;
